import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {};

export const noDataTitleBox: SxStyle = {
  position: 'relative',
  display: 'inline-flex',
  minWidth: (p) => p.spacing(10),
  maxWidth: '100%',
  height: 'auto',
};

export const noDataTitleBox1: SxStyle = {
  position: 'absolute',
  background: (p) => p.palette.grey[50],
  borderRadius: (p) => p.spacing(5),
  width: '100%',
  height: '100%',
  top: (p) => p.spacing(2),
};

export const noDataTitleBox2: SxStyle = {
  position: 'absolute',
  background: (p) => p.palette.grey[200],
  borderRadius: (p) => p.spacing(2),
  width: '100%',
  height: '100%',
  top: (p) => p.spacing(1),
};

export const noDataTitleWrapper: SxStyle = {
  position: 'relative',
  background: (p) => p.palette.common.white,
  width: '100%',
  border: '1px solid',
  borderColor: (p) => p.palette.grey[300],
  borderRadius: (p) => p.spacing(1),
  padding: (p) => p.spacing(1.25, 2),
  boxSizing: 'border-box',
};

export const emptyIconWrapper: SxStyle = {
  borderWidth: '1px',
  borderStyle: 'solid',
  borderColor: (p) => p.palette.grey[300],
  outlineWidth: (p) => p.spacing(0.5),
  outlineStyle: 'solid',
  outlineColor: (p) => p.palette.grey[200],
  padding: (p) => p.spacing(1.5),
  borderRadius: (p) => p.spacing(2),
  background: (p) => p.palette.common.white,
};

export const noDataContent: SxStyle = {
  height: 'auto',
  padding: (p) => p.spacing(10, 0),
  width: '100%',
};

export const emptyIconBox: SxStyle = {
  background: (p) => p.palette.grey[50],
  borderRadius: (p) => p.spacing(2),
  padding: (p) => p.spacing(0.75),
  display: 'inline-block',
};

export const emptyIcon: SxStyle = {
  color: (p) => p.palette.grey[400],
};
